import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="modal"
export default class extends Controller {
  connect() {
  }

  clearTooltips() {
    $('[data-bs-toggle="tooltip"]').each(function(){
      $(this).tooltip('hide')
    })
  }

  loadModal(event) {
    let focus_modal = true;
    // Change for data-focus="no"
    if (event.currentTarget.dataset && event.currentTarget.dataset.focus && (event.currentTarget.dataset.focus == "no")) {
      focus_modal = false;
    }

    if (event.currentTarget.dataset && event.currentTarget.dataset.bsToggle && event.currentTarget.dataset.bsToggle == 'tooltip') {
      // Tooltips on buttons that open modals do not always cleanly close -- remove with force :)
      $(event.currentTarget).blur();
      setTimeout(function(){
        $(".tooltip[role='tooltip']").remove();
      },100);
      // $(event.currentTarget).tooltip('dispose');
    }

    this.modal = new Modal(document.getElementById('system_modal'), {
      keyboard: false,
      focus: focus_modal
    });

    // let modal_container = document.querySelector('#system_modal');
    // this.removeBootstrapModalSizes(modal_container);
    // if (event.currentTarget.dataset && event.currentTarget.dataset.modalSize) {
    //   if (modal_container) {
    //     let dialog_container = modal_container.querySelector('.modal-dialog');
    //     if (dialog_container) {
    //       dialog_container.className = "modal-dialog " + event.currentTarget.dataset.modalSize;
    //     }
    //   }
    // } else {
    //   this.setDefaultBootstrapModalSize(modal_container);
    // }

    this.modal.show();
    this.clearTooltips();
  }
}
